import {useEventBus} from '@vueuse/core'

export const usePeerErrorCallback = () => {
  useEventBus('strategy:error').on((event: any) => {
    // todo
    console.warn('peer error ', event)
  })
}
